var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #999594;\n      }\n\n      .cls-2 {\n      stroke: #1d1d1b;\n      stroke-width: 1.17px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n      fill: none;\n      }\n\n      .cls-5 {\n      fill: #95c11f;\n      }\n\n      .cls-6 {\n      fill: #fff;\n      }\n\n      .cls-7 {\n      fill: #1d1d1b;\n      }\n\n      .cls-4 {\n      stroke: #95c11f;\n      stroke-width: 1.18px;\n      }\n\n      .cls-8 {\n      clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.8,14.07h42.72c3.73,0,6.77,3.03,6.77,6.77v38.19c0,3.73-3.03,6.77-6.77,6.77h-42.73c-3.73,0-6.77-3.03-6.77-6.77V20.84c0-3.74,3.03-6.77,6.77-6.77Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.53,14.07h-2.54c-.07-.09-.15-.15-.24-.15,0-.86.04-1.66,0-2.46-.14-2.26-1.81-4.05-4.04-4.37-2.44-.35-4.86,1.49-5.14,3.95-.11.92-.1,1.85-.15,2.83h-4.67c-.04-.87-.05-1.76-.13-2.63-.2-2.33-2.28-4.21-4.61-4.2-2.36.02-4.44,1.94-4.59,4.29-.05.82,0,1.65,0,2.53h-4.86c0-.79.04-1.57,0-2.35-.14-2.28-1.79-4.08-4-4.41-2.45-.36-4.87,1.43-5.18,3.9-.12.94-.11,1.89-.17,2.96-.1,0-.19.04-.27.11h-2.11c-3.74,0-6.77,3.03-6.77,6.77v38.19c0,3.74,3.03,6.77,6.77,6.77h42.72c3.74,0,6.77-3.03,6.77-6.77V20.84c0-3.74-3.03-6.77-6.77-6.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 123.49,
    y: 26.71,
    width: 8.5,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 123.5,
    y: 37.89,
    width: 8.47,
    height: 8.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 157.88,
    y: 37.9,
    width: 8.5,
    height: 8.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 134.94,
    y: 26.71,
    width: 8.51,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 146.43,
    y: 26.7,
    width: 8.46,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 157.9,
    y: 26.7,
    width: 8.46,
    height: 8.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 134.96,
    y: 37.9,
    width: 8.46,
    height: 8.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.91,37.9c0,2.78,0,5.52,0,8.3h-8.49v-8.3s8.49,0,8.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.48,57.37c0-2.74,0-5.48,0-8.26h8.51v8.26s-8.51,0-8.51,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M162.31,53.51c0,2.77,4.09,1.08,4.09,3.85h-8.52v-8.25c2.82,0,1.54,4.4,4.43,4.4"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 134.96,
    y: 49.08,
    width: 8.46,
    height: 8.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 146.42,
    y: 49.1,
    width: 8.49,
    height: 8.28
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.75 15.67 160.44 50.94 178.32 61.85 169.74 69.58 128.43 66.62 111.83 21.6 110.75 15.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "111.11 19.69 130.23 66.62 126.53 66.51 111.11 19.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "110.43 15.5 177.37 59.1 176.73 63.44 110.43 15.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.55 19.37 162.54 72.76 152.09 72.87 112.55 19.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.9,
    y: 27.74,
    width: 4.92,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.09,
    y: 35.56,
    width: 7.63,
    height: 2.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 131.29,
    y: 46.07,
    width: 11.76,
    height: 3.71
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.81,62.92c-.7-6.61-1.36-12.96-2.05-19.48-5.3,3.85-10.46,7.59-15.8,11.48,1.8.8,3.41,1.52,5.22,2.32-3.86,6.9-9.53,10.94-17.11,12.22-6.4,1.08-12.33-.36-17.7-3.97-5.31-3.57-8.64-8.61-10.41-14.76-.13.04-.26.07-.39.11,0,.35-.07.72,0,1.06,1.56,7.78,5.65,13.9,12.34,18.15,13.43,8.53,31.21,4.34,39.84-8.73.43-.66.83-.77,1.53-.44,1.41.68,2.85,1.29,4.53,2.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M142.99,16.1h0c0,1.49-.03,2.98,0,4.46.03,1.09.9,1.95,1.92,2,1.02.05,1.92-.73,2.08-1.82.03-.22.05-.45.05-.68,0-2.63,0-5.25,0-7.88,0-.29-.02-.58-.08-.86-.16-.74-.59-1.27-1.31-1.54-1.27-.48-2.63.47-2.67,1.91-.04,1.47,0,2.93,0,4.4M161.15,16.14h0c0-1.41,0-2.81,0-4.22-.01-1.28-.86-2.23-1.99-2.27-1.12-.03-2.07.9-2.08,2.17-.04,2.85-.02,5.71,0,8.56,0,.86.39,1.56,1.19,1.96,1.33.67,2.84-.33,2.88-1.93.03-1.43,0-2.85,0-4.28M132.94,16.12h0c0-1.41.01-2.81,0-4.22-.01-1.27-.88-2.23-2.01-2.25-1.12-.02-2.05.92-2.07,2.19-.03,2.83-.02,5.66,0,8.5,0,.89.39,1.61,1.21,2.02,1.33.66,2.83-.35,2.86-1.96.03-1.43,0-2.85,0-4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.94,14.74h-4.5v12.65l-8.4-12.65h-4.12v21.61h4.48v-13.07l8.69,13.07h3.86V14.74ZM53.52,14.76h-4.14l-8.02,21.67h10.25v-4.3h-4.12l3.92-11.04,5.44,15.34h4.71l-8.04-21.67ZM39.03,31.88h-9.33V14.74h-4.53v21.61h13.86v-4.46ZM12.15,19.17h2.95c2.1.06,3.15,1.13,3.15,3.21-.12,2.12-1.14,3.18-3.06,3.18h-2.8l2.52,4.37c2.26,0,4.15-.65,5.65-1.95,1.51-1.29,2.26-3.21,2.26-5.75-.3-4.99-2.76-7.49-7.38-7.49h-7.83v21.61h4.53v-17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.94,14.74h-4.5v12.65l-8.4-12.65h-4.12v21.61h4.48v-13.07l8.69,13.07h3.86V14.74ZM53.52,14.76h-4.14l-8.02,21.67h10.25v-4.3h-4.12l3.92-11.04,5.44,15.34h4.71l-8.04-21.67ZM39.03,31.88h-9.33V14.74h-4.53v21.61h13.86v-4.46ZM12.15,19.17h2.95c2.1.06,3.15,1.13,3.15,3.21-.12,2.12-1.14,3.18-3.06,3.18h-2.8l2.52,4.37c2.26,0,4.15-.65,5.65-1.95,1.51-1.29,2.26-3.21,2.26-5.75-.3-4.99-2.76-7.49-7.38-7.49h-7.83v21.61h4.53v-17.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.53,55.98h5.65v-4.8h-10.26v14.22h16.42v-4.8h-11.81v-4.62ZM83.92,46.54h16.42v-4.8h-16.42v4.8ZM68.13,65.56h4.53l8.61-23.85h-5.5l-5.32,15.94-5.31-15.94h-5.62l8.61,23.85ZM51.74,65.4h5.13v-23.69h-5.13v23.69ZM43.89,56.94c3-1.06,4.5-3.52,4.5-7.39,0-2.21-.61-3.99-1.81-5.36-1.5-1.66-3.63-2.49-6.4-2.49h-9.91v23.69h5.13v-18.82h4.38c2.28.03,3.42,1.14,3.42,3.33-.11,2.15-1.22,3.23-3.33,3.23h-4.19l7.52,12.27h5.88l-5.19-8.45ZM12.76,60.53v-13.96h3.35c4.09.54,6.13,2.88,6.13,7.04-.43,4.61-2.48,6.91-6.13,6.91h-3.35ZM24.42,61.97c2.13-2.32,3.2-5.13,3.2-8.45s-1.07-6.11-3.2-8.39c-2.09-2.28-4.87-3.42-8.31-3.42H7.63v23.69h8.48c3.45,0,6.22-1.14,8.31-3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.53,55.98h5.65v-4.8h-10.26v14.22h16.42v-4.8h-11.81v-4.62ZM83.92,46.54h16.42v-4.8h-16.42v4.8ZM68.13,65.56h4.53l8.61-23.85h-5.5l-5.32,15.94-5.31-15.94h-5.62l8.61,23.85ZM51.74,65.4h5.13v-23.69h-5.13v23.69ZM43.89,56.94c3-1.06,4.5-3.52,4.5-7.39,0-2.21-.61-3.99-1.81-5.36-1.5-1.66-3.63-2.49-6.4-2.49h-9.91v23.69h5.13v-18.82h4.38c2.28.03,3.42,1.14,3.42,3.33-.11,2.15-1.22,3.23-3.33,3.23h-4.19l7.52,12.27h5.88l-5.19-8.45ZM12.76,60.53v-13.96h3.35c4.09.54,6.13,2.88,6.13,7.04-.43,4.61-2.48,6.91-6.13,6.91h-3.35ZM24.42,61.97c2.13-2.32,3.2-5.13,3.2-8.45s-1.07-6.11-3.2-8.39c-2.09-2.28-4.87-3.42-8.31-3.42H7.63v23.69h8.48c3.45,0,6.22-1.14,8.31-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.38,37.36l3.07-2.73-3.05-3.27c.41-.75.79-1.53,1.14-2.33.09-.24.19-.47.28-.71.24-.57.47-1.12.68-1.66l-3.55-2.19c-.32.83-.6,1.57-.84,2.22-.26.64-.46,1.14-.63,1.49l-2.46-2.61c.52-.25,1.02-.56,1.48-.95.49-.36.89-.78,1.2-1.27.31-.47.54-1.02.67-1.63.15-.6.2-1.27.14-2v-.06c-.07-.75-.25-1.48-.57-2.19-.3-.67-.72-1.28-1.26-1.81-.53-.51-1.15-.92-1.85-1.24-.69-.29-1.47-.43-2.33-.43-.97,0-1.82.16-2.53.5-.7.35-1.28.81-1.74,1.38-.47.54-.8,1.16-.98,1.86-.2.7-.26,1.44-.2,2.2v.06c.07.75.23,1.49.49,2.22.28.71.68,1.44,1.21,2.19-1.12.64-1.96,1.47-2.5,2.48-.56,1.04-.79,2.26-.67,3.66v.06c.09.98.32,1.87.71,2.67.39.79.9,1.46,1.54,2.03.62.6,1.35,1.04,2.19,1.33.83.32,1.71.48,2.66.48,1.13,0,2.15-.23,3.06-.7.9-.47,1.65-1.03,2.23-1.66l2.4,2.6ZM90.66,21.58c-.19-.4-.31-.86-.35-1.36v-.06c-.06-.7.05-1.23.33-1.58.28-.38.65-.57,1.11-.57.43,0,.81.17,1.15.5.33.34.52.83.57,1.47v.06c.06.69-.1,1.26-.47,1.71-.36.45-.86.81-1.51,1.09-.32-.41-.6-.83-.83-1.24M90.03,32.25c-.5-.43-.78-1.05-.85-1.84v-.06c-.05-.57.04-1.1.27-1.58.21-.5.54-.88.99-1.15l3.79,4.14c-.37.37-.76.66-1.17.85-.4.21-.81.31-1.24.31-.7,0-1.3-.22-1.79-.67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b1c7f2e677b8906ac21d55d41ad13da.svg";
export { ForwardRef as ReactComponent };